import { useState } from 'react'
import Modal from './Modal'

export default function PasswordModal({ saving, onClose, onSave }) {
  const [password, setPassword] = useState('')
  const [confirmation, setConfirmation] = useState('')
  const [error, setError] = useState('')

  async function handleSubmit(event) {
    event.preventDefault()
    setError('')

    if (password.length < 8) {
      setError('Use at least 8 characters.')
      return
    }

    if (password !== confirmation) {
      setError('The passwords do not match.')
      return
    }

    try {
      await onSave(password)
    } catch (saveError) {
      setError(saveError.message || 'The password could not be updated.')
    }
  }

  return (
    <Modal
      className="password-modal"
      onClose={onClose}
      subtitle="Use this password for future sign-ins. No email link will be needed."
      title="Set password"
    >
      <form onSubmit={handleSubmit}>
        <div className="modal-body form-stack">
          <label className="field-label" htmlFor="new-password">
            New password
            <input
              autoComplete="new-password"
              autoFocus
              id="new-password"
              minLength="8"
              onChange={(event) => setPassword(event.target.value)}
              placeholder="At least 8 characters"
              required
              type="password"
              value={password}
            />
          </label>

          <label className="field-label" htmlFor="confirm-password">
            Confirm password
            <input
              autoComplete="new-password"
              id="confirm-password"
              minLength="8"
              onChange={(event) => setConfirmation(event.target.value)}
              placeholder="Enter the password again"
              required
              type="password"
              value={confirmation}
            />
          </label>

          {error ? <p className="form-error">{error}</p> : null}
        </div>

        <footer className="modal-footer">
          <button className="button button--secondary" disabled={saving} onClick={onClose} type="button">
            Cancel
          </button>
          <button className="button button--primary" disabled={saving} type="submit">
            {saving ? 'Saving…' : 'Save password'}
          </button>
        </footer>
      </form>
    </Modal>
  )
}
